import { getStoreId } from "$/hooks/use-store-information"
import serviceSettingsQueries from "$/lib/queries/service-settings-queries"
import standardOfferingQueries from "$/lib/queries/standard-offering-queries"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth/settings/services")({
  loader: async ({ context: { queryClient } }) => {
    const storeId = await getStoreId()
    if (storeId) {
      queryClient.prefetchQuery(standardOfferingQueries.list(storeId))
      queryClient.prefetchQuery(serviceSettingsQueries.detail(storeId))
    }

    return {
      crumb: "alfred.settings.crumbs.services",
    }
  },
})
